import { ICheckYourEmailAdapter } from 'application/modules/auth/useCases/hooks/useCaseCheckYourEmail';
import useCaseExternalNavigation from 'application/modules/bookingWizard/useCases/hooks/useCaseNavigateTo';
import mboAPI from 'infrastructure/redux/adapters/mboAPI/mboApi';
import { selectAccessToken } from 'infrastructure/redux/slices/auth.selector';
import { useAppSelector } from 'infrastructure/redux/store/hooks';
import { withSentry } from 'infrastructure/services/sentryLazy';
const useCheckYourEmail: ICheckYourEmailAdapter = () => {
  const accessToken = useAppSelector(selectAccessToken);
  const { openPageInANewTab } = useCaseExternalNavigation();
  const [loginAndSendEmail, { isLoading, error, data }] = mboAPI.useLogInWithEmailMutation();

  const navigateToEmailProviderMailbox = (providerUrl: string, email?: string) => {
    openPageInANewTab(`${providerUrl}${email}`);
  };

  const handleResendVerificationLink = async (
    email: string,
    locationId: string,
    bookingUUID?: string,
  ) => {
    await loginAndSendEmail({ email, locationId, bookingUUID });
  };

  const handleNavigateToGenericMailbox = async () => {
    try {
      window.location.assign('mailto:');
    } catch (error) {
      withSentry((Sentry) =>
        Sentry.captureException(error, {
          level: 'warning',
          tags: {
            error_type: 'browser_compatibility',
            error_source: 'mailto_protocol',
            feature: 'email_client_launch',
          },
          contexts: {
            browser: {
              action: 'open_email_client',
              protocol: 'mailto:',
            },
          },
        }),
      );
      console.warn('Failed to open email client:', error);
    }
  };

  return {
    inProgress: isLoading,
    isLoggedIn: !!accessToken,
    result: data,
    error: error,
    navigateToEmailProviderMailbox,
    resendVerificationLink: handleResendVerificationLink,
    navigateToGenericMailbox: handleNavigateToGenericMailbox,
  };
};

export default useCheckYourEmail;
